import React from 'react';
import { styled } from '@linaria/react';
import { ButtonSize } from '.';
interface Props {
  size?: ButtonSize;
  className?: string;
}
export const ButtonLoadingWrapper = /*#__PURE__*/styled('div')({
  name: "ButtonLoadingWrapper",
  class: "bgawhpb",
  propsAsIs: false
});
const _exp4 = /*#__PURE__*/() => ({
  size
}) => ({
  sm: 8,
  md: 8,
  lg: 12,
  xl: 12
})[size];
const _exp5 = /*#__PURE__*/() => ({
  delay
}) => delay;
export const LoadingBullet = /*#__PURE__*/styled('div')({
  name: "LoadingBullet",
  class: "lzz5jyc",
  propsAsIs: false,
  vars: {
    "lzz5jyc-0": [_exp4(), "px"],
    "lzz5jyc-1": [_exp5()]
  }
});
export const LoadingBullets = ({
  size = 'md',
  className
}: Props) => {
  return <ButtonLoadingWrapper className={className}>
      <LoadingBullet size={size} delay="0s" />
      <LoadingBullet size={size} delay="0.2s" />
      <LoadingBullet size={size} delay="0.4s" />
    </ButtonLoadingWrapper>;
};

require("./LoadingBullets.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./LoadingBullets.tsx");